
import { Vue, Component, Prop } from "vue-property-decorator";
import Parameter from "../components/Parameter.vue";
import DiagramTableSwitch from "@/components/DiagramTableSwitch.vue";
import Loader from "@/components/Multiloader.vue";

@Component({ components: { Loader, Parameter, DiagramTableSwitch } })
export default class Zeitreihen extends Vue {
  @Prop({ required: true })
  id!: string;

  where: string[] = [];

  get columns() {
    return [
      {
        text: "Datum",
        key: "DATUM"
      },
      {
        text: "Parameter",
        key: "STOFF_NR"
      },
      {
        text: "Bezeichnung",
        key: "STOFF_BEZ"
      },
      {
        text: "Status",
        key: "STATUS_BEZ"
      },
      {
        text: "Wert",
        key: "WERT"
      },
      {
        text: "Einheit",
        key: "EINHEIT_BEZ"
      }
    ];
  }

  formatData(data: any[]) {
    let einheitBez = null;
    let parameterBez = null;
    const list = data
      // map data to format
      .map(messwert => {
        einheitBez = messwert.EINHEIT_BEZ;
        parameterBez = messwert.PARAM_NAME;

        const parameterStatus =
          messwert.STATUS_BEZ == null || messwert.STATUS_BEZ == "normal"
            ? "-"
            : messwert.STATUS_BEZ;

        const element = {
          // default data
          xValue: Date.parse(messwert.ANA_DATUM),
          yValue: messwert.WERT,
          // specific data
          parameterStatus: parameterStatus
        };
        return Object.assign(messwert, element);
      });

    // TODO: paramNr is a property in the where parameter - need a good way to extract them.
    const paramNr = "";

    // create diagram object
    return {
      // default data
      xUnit: "",
      yUnit: einheitBez,
      legendText: "Messwerte Chemie",
      // specific data
      parameterBezeichnung: parameterBez,
      parameter: paramNr,
      // value list
      list
    };
  }
}
